import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from "@mui/system";
import { theme } from "./Tema";
import { HelmetProvider } from 'react-helmet-async';

const rootElement = document.getElementById('root');

const AppTree = (
    <HelmetProvider>
        <ThemeProvider theme={theme}>
            <App />
        </ThemeProvider>
    </HelmetProvider>
);

if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, AppTree);
} else {
    createRoot(rootElement).render(AppTree);
}

serviceWorkerRegistration.unregister();
reportWebVitals();